export const getTimeOffset = () => (new Date().getTimezoneOffset());